import { adminInstance } from "@/api/instance";

export default async function (lectureId, data) {
  return adminInstance.put(`/lecture/${lectureId}`, data);
}
